import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, CreditCardIcon, RefreshCwIcon } from 'lucide-react';
interface Service {
  icon: React.ReactNode;
  title: string;
  description: string;
}
const services: Service[] = [{
  icon: <SparklesIcon className="w-8 h-8" aria-hidden="true" data-id="element-192" />,
  title: 'White-Glove Concierge Service',
  description: 'Experience unparalleled personalized service from our dedicated team. From private viewings to home delivery, we ensure every detail exceeds expectations.'
}, {
  icon: <CreditCardIcon className="w-8 h-8" aria-hidden="true" data-id="element-193" />,
  title: 'Premium Financing Solutions',
  description: 'Tailored financing options designed for discerning clients. Our specialists work with premier institutions to craft bespoke financial arrangements.'
}, {
  icon: <RefreshCwIcon className="w-8 h-8" aria-hidden="true" data-id="element-194" />,
  title: 'Exclusive Trade-In Program',
  description: 'Maximize the value of your current vehicle with our transparent appraisal process. We offer competitive valuations and seamless transitions.'
}];
export function Services() {
  return <section className="w-full bg-[var(--color-black-deep)] py-24 px-6" data-id="element-195">
      <div className="max-w-7xl mx-auto" data-id="element-196">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-197">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4" data-id="element-198">
            Exceptional Service
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto font-light" data-id="element-199">
            Every aspect of your experience is crafted with meticulous attention
            to detail
          </p>
        </motion.div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-200">
          {services.map((service, index) => <motion.article key={service.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.2,
          ease: [0.22, 1, 0.36, 1]
        }} className="text-center" data-id="element-201">
              {/* Icon */}
              <div className="inline-flex items-center justify-center w-16 h-16 mb-6 text-[var(--color-gold)] border-2 border-[var(--color-gold)] rounded-full" data-id="element-202">
                {service.icon}
              </div>

              {/* Content */}
              <h3 className="text-2xl font-semibold text-white mb-4" data-id="element-203">
                {service.title}
              </h3>
              <p className="text-gray-400 leading-relaxed font-light" data-id="element-204">
                {service.description}
              </p>
            </motion.article>)}
        </div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-center mt-16" data-id="element-205">
          <button className="inline-flex items-center gap-2 border-2 border-[var(--color-gold)] text-[var(--color-gold)] px-8 py-4 text-lg font-medium hover:bg-[var(--color-gold)] hover:text-black transition-all duration-300" aria-label="Schedule a consultation with our team" data-id="element-206">
            Schedule Consultation
          </button>
        </motion.div>
      </div>
    </section>;
}